module.exports = __webpack_public_path__ + "static/img/Sym4.7b0407a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sym4.png
// module id = AzOo
// module chunks = 36